import { useScreenSize } from '@main/ScreenSizeContext';

export default function useIsTablet(): boolean {
  const { isTablet } = useScreenSize();

  return isTablet;
}
